import { isMobile } from './device';

((document, window) => {
  const baseSize = 16;
  const html = document.documentElement;
  const setRem = () => {
    const designSize = isMobile() ? 390 : 1920;
    const width = html.getBoundingClientRect().width;
    const scale = width / designSize;
    const fontSize = baseSize * scale + 'px';
    html.style.fontSize = fontSize;
  };

  window.addEventListener('resize', setRem);

  setRem();
})(document, window);
